export const APP_BOOTSTRAP_TO_REDIRECT_VITAL = 'app_bootstrap_to_redirect';
